import { Component, Input, OnInit } from '@angular/core';
import DetailCredit from '@model/detailCredit/detailCredit';

@Component({
  selector: 'app-payment-reference',
  templateUrl: './payment-reference.component.html',
  styleUrls: ['./payment-reference.component.css'],
})
export class PaymentReferenceComponent implements OnInit {
  @Input()
  public detailCredit: DetailCredit;

  public valueMinPay: number;
  public product: string;
  public loanId: number;
  public limitDate: Date;

  constructor() {}

  ngOnInit() {
    this.valueMinPay = 0;
    this.loanId = 0;
    this.product = '';
    this.buildData();
  }

  private buildData() {
    let stateMora = this.detailCredit.stateActual.stateMora;
    this.product = this.detailCredit.product;
    this.loanId = this.detailCredit.loanId;
    this.valueMinPay = this.detailCredit.stateActual.miniPayment;
    this.limitDate = stateMora ? null : this.detailCredit.stateActual.limitDate;
  }
}
